import { useState, type FormEvent } from "react";
import { updateProfile } from "firebase/auth";
import { auth } from "../lib/firebase";
import { api, callableErrorMessage } from "../lib/api";

export function NameCaptureCard({ onDone }: { onDone: () => void }) {
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [saved, setSaved] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (name.trim().length < 2) return;
    setBusy(true);
    setError(null);
    try {
      await api.updateCustomerProfile({ displayName: name.trim() });
      if (auth.currentUser) {
        await updateProfile(auth.currentUser, { displayName: name.trim() });
        await auth.currentUser.reload();
      }
      setSaved(true);
      setTimeout(onDone, 1200);
    } catch (err) {
      setError(callableErrorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  if (saved) {
    return (
      <section className="card text-center text-sm text-leaf-800">
        Gracias. Te vamos a reconocer la proxima vez.
      </section>
    );
  }

  return (
    <section className="card flex flex-col gap-3">
      <div>
        <p className="text-xs uppercase tracking-wider text-leaf-600">Personaliza tu cuenta</p>
        <h3 className="mt-1 font-display text-lg font-semibold text-leaf-950">
          Guarda tu nombre para que nos acordemos de ti en tu proxima visita
        </h3>
      </div>
      <form onSubmit={submit} className="flex flex-col gap-2">
        <input
          autoFocus
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Como te llamas"
          maxLength={60}
          className="input"
        />
        {error && <p className="text-xs text-red-700">{error}</p>}
        <div className="flex gap-2">
          <button
            type="button"
            onClick={onDone}
            className="btn-ghost flex-1 text-sm"
          >
            Ahora no
          </button>
          <button
            type="submit"
            disabled={busy || name.trim().length < 2}
            className="btn-primary flex-1 disabled:opacity-50"
          >
            {busy ? "Guardando…" : "Guardar"}
          </button>
        </div>
      </form>
    </section>
  );
}
